import React from "react";
import { motion } from "framer-motion"; // Import Framer Motion
import "../../assets/styles/comfour.css";
import bb6 from "../../assets/images/bb6.png";
import { useNavigate } from "react-router-dom";

const ComFour = () => {
  const navigate = useNavigate(); 
  return (
    <section
      className="comfour-container"
     
    >
      <div className="comfour-content">
        {/* Animated Image */}
        <motion.img
          src={bb6}
          alt="Knowledge Hub"
          className="comfour-image"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: "easeInOut" }}
        />

        {/* Animated Text Section */}
        <motion.div
          className="comfour-text"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          transition={{ staggerChildren: 0.3 }}
        >
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, ease: "easeInOut" }}
          >
            commceed KNOWLEDGE HUB
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
          >
            At commceed, we believe that the foundation of every successful
            project starts with knowledge. Our Knowledge Hub is your go-to
            resource for insightful information, expert advice, and the latest
            trends in cabling, network infrastructure, and IT solutions. Whether
            you're a business leader, an IT professional, or a contractor, our
            hub is designed to empower you with the tools and understanding
            needed to make informed decisions.
          </motion.p>

          {/* Animated Button */}
          <motion.button
            className="comfour-button"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, ease: "easeInOut", delay: 0.4 }}
            whileHover={{ scale: 1.1 }}
            onClick={() => navigate("/knowledgehub")}
          >
            KNOWLEDGE HUB
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default ComFour;
